export const darkPalette = {
  // Primary (Header) colors - slightly brighter for dark mode
  headerColor: 'rgb(146, 95, 27)',
  headerBrightColor: '#ffb85f',
  headerDimColor: '#d48216',
  headerTransparentColor: 'rgba(146, 95, 27, 0.6)',
  headerTransparentThinColor: 'rgba(146, 95, 27, 0.2)',

  // Background colors - inverted
  background: '#2d2b2b',
  paperColor: '#2d2d2d',
  paperColorDim: '#3a3a3a',
  paperColorDim2: '#4a4a4a',
  paperColorTransparent: 'rgba(45, 45, 45, 0.6)',
  paperColorInput: '#333333',
  paperColorDivider: '#555555',

  // Text colors - inverted
  textColor: '#cdcdcd',
  textColorSecondary: '#918a8a',

  // Status colors - adjusted for dark backgrounds
  successText: '#4caf50',
  successMain: '#1b5e20',
  errorText: '#f44336',
  errorMain: '#5d1f1a',
  warningText: '#ffb300',
  warningMain: '#5d4a1f',
  infoText: '#29b6f6',
  infoMain: '#1a3e4a',

  // Secondary colors - adjusted
  secondaryBright: '#757575',
  secondaryMain: '#5a5a5a',

  // Action colors
  actionDisabled: '#5a5a5a',
  actionSelected: '#ff9100',

  // Additional
  mapBackground: '#1e1f1a',
  mapTextColor: '#ffffff',
  achievementStroke: '#e9a957',
  disabledOverlay: 'rgba(255, 255, 255, 0.15)',
  shadowColor: '#000000'
}
